<template>
  <div>
    <main role="main">
      <div class="page-content">
        <div class="container py-md-5 py-4">
          <div class="row align-items-center mb-4">
            <div class="col-md-4">
              <h2 class="page-title mb-md-0 mb-3">My ID PROOF</h2>
            </div>
            <div class="col-md-8 form-style d-flex justify-content-end">
              <p class="text-danger fst-italic">
                Note : Your ID will not be Shared & Visible to other members
              </p>
            </div>
          </div>
          <div class="mb-4">
            <p class="font-medium text-uppercase" style="color: #f11919">
              Please Select any one from below For address & ID Proof
            </p>
          </div>
          <Form ref="changePasswordForm" @submit="saveDocument">
            <div
              class="row row-cols-2 row-cols-md-3 row-cols-lg-5 mb-md-5 mb-4"
            >
              <div class="col mb-lg-0 mb-4">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="IdType"
                    id="DrivingLiecense"
                    value="LICENCE"
                    v-on:click="uploadnewDocuemnt('LICENCE')"
                    v-model="documentDetail.type"
                  />
                  <label class="form-check-label" for="DrivingLiecense">
                    Driving License
                  </label>
                </div>
              </div>
              <div class="col mb-lg-0 mb-4">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="IdType"
                    id="PANCard"
                    value="PANCARD"
                    v-on:click="uploadnewDocuemnt('PANCARD')"
                    v-model="documentDetail.type"
                  />
                  <label class="form-check-label" for="PANCard">
                    PAN Card
                  </label>
                </div>
              </div>
              <div class="col mb-lg-0 mb-4">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="IdType"
                    id="VoterID"
                    value="VOTER_ID"
                    v-model="documentDetail.type"
                    v-on:click="uploadnewDocuemnt('VOTER_ID')"
                    rules="required"
                    :validateOnInput="true"
                  />
                  <label class="form-check-label" for="VoterID">
                    Voter ID
                  </label>
                </div>
              </div>
              <div class="col mb-lg-0 mb-4">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="IdType"
                    id="Passport"
                    value="PASSPORT"
                    v-on:click="uploadnewDocuemnt('PASSPORT')"
                    v-model="documentDetail.type"
                    rules="required"
                    :validateOnInput="true"
                  />
                  <label class="form-check-label" for="Passport">
                    Passport
                  </label>
                </div>
              </div>
              <div class="col">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="IdType"
                    id="Aadhaar"
                    value="AADHAR"
                    v-model="documentDetail.type"
                    v-on:click="uploadnewDocuemnt('AADHAR')"
                    rules="required:type"
                    :validateOnInput="true"
                  />
                  <label class="form-check-label" for="Aadhaar">
                    Aadhaar
                  </label>
                </div>
              </div>
              <ErrorMessage name="IdType" class="text-danger" />
            </div>

            <!-- <div class="row form-style">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Enter ID Card Number</label>
                  <Field
                    type="text"
                    class="form-control"
                    name="id_number"
                    v-model="documentDetail.id_number"
                    rules="required:document number"
                    :validateOnInput="true"
                  />
                  <ErrorMessage name="id_number" class="text-danger" />
                </div>
              </div>
            </div> -->
            <div class="row form-style">
              <div class="col-md-6 mb-4">
                <p class="mb-0 pb-0" v-if="documentDetail.type != 'PASSPORT'">
                  Front Image
                </p>
                <DocumentPicker
                  :src="
                    documentDetail.front_image ? documentDetail.front_image : ''
                  "
                  :uuid="documentDetail.uuid"
                  :file_name="documentDetail.front_file_name"
                  :type="'FRONT_IMAGE'"
                  ref="documentFrontImage"
                  @removeDocument="showpopup($event, 'FRONT')"
                />
              </div>
              <div class="col-md-6 mb-4 p-0">
                <p class="mb-0 pb-0" v-if="documentDetail.type != 'PASSPORT'">
                  Back Image
                </p>
                <DocumentPicker
                  :src="
                    documentDetail.back_image ? documentDetail.back_image : ''
                  "
                  :uuid="documentDetail.uuid"
                  :type="'BACK_IMAGE'"
                  :file_name="documentDetail.back_file_name"
                  ref="documentBackImage"
                  @removeDocument="showpopup($event, 'BACK')"
                />
              </div>
              <div class="col-12 mb-4">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="coreectInfo"
                    rules="required"
                    value="true"
                    v-model="isChecked"
                    :validateOnInput="true"
                  />
                  <label class="form-check-label" for="coreectInfo">
                    I hereby declare that the information provided is correct.
                  </label>
                </div>
              </div>
            </div>

            <div class="col-12 text-center">
              <button id="submit-Button" class="btn btn-brand-1 px-5">
                Submit
              </button>
            </div>
          </Form>
        </div>
      </div>
    </main>
    <ErrorComponent @retry="getDoumentDetail()" ref="errorComponent" />

    <TextModal ref="confirmationPopup">
      <div>
        <div class="row col-12 px-md-5 border-0 p-4 text-align-last-center">
          <div class="col-1" style="text-align-last: end"></div>
        </div>
        <div class="modal-body pt-0 form-style row">
          <div class="col-12 row" style="margin-top: -43px">
            <div class="col-8">
              <h5 class="modal-title">Delete Document</h5>
            </div>
            <div class="col-4">
              <button
                style="margin-top: -57px"
                type="button"
                class="btn-close"
                v-on:click="$refs.confirmationPopup.closeModal()"
              ></button>
            </div>
          </div>

          <div class="form-group mt-3">
            <!-- <h4 class="text-center">You are a free member</h4> -->
            <p>Are you sure want to remove Document ?</p>
          </div>
          <div class="text-center" style="margin-top: 10px">
            <a
              style="cursor: pointer"
              class="btn btn-brand-1 btn-block"
              v-on:click="remooveDocument()"
            >
              Yes
            </a>
            <a
              style="margin-left: 61px !important; cursor: pointer"
              class="btn btn-brand-1 btn-block"
              v-on:click="$refs.confirmationPopup.closeModal()"
            >
              No
            </a>
          </div>
        </div>
      </div>
    </TextModal>
  </div>
</template>

<script>
// import ErrorComponent from "@/components/ErrorComponent";
import { Form, ErrorMessage } from "vee-validate";
import ErrorComponent from "@/components/ErrorComponent";
import DocumentPicker from "@/components/DocumentPicker.vue";
import TextModal from "@/components/TextModal.vue";
export default {
  name: "MyId",
  components: {
    Form,
    ErrorComponent,
    TextModal,
    ErrorMessage,
    DocumentPicker,
  },
  data() {
    return {
      uuid: "",
      type: "",
      documentDetail: {
        type: "LICENCE",
      },
      obj: {
        type: "",
      },
      isChecked: false,
    };
  },
  mounted() {
    this.getDoumentDetail();
    this.moveToContacat();
  },
  methods: {
    moveToContacat() {
      if (window.location.pathname == "/dashboard") {
        window.scrollTo(0, 0);
      }
    },

    showpopup(e) {
      this.uuid = e.uuid;
      this.type = e.type;
      this.$refs.confirmationPopup.showModal();
    },
    remooveDocument() {
      if (this.uuid) {
        this.$api
          .putAPI({
            _action: "/remove-document",
            _body: {
              uuid: this.uuid,
              type: this.type,
            },
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            if (this.type == "FRONT_IMAGE") {
              this.documentDetail.front_image = "";
              this.$refs.documentFrontImage.selectFile = null;
              this.$refs.documentFrontImage.file = undefined;
            }
            if (this.type == "BACK_IMAGE") {
              this.documentDetail.back_image = "";
              this.$refs.documentBackImage.selectFile = null;
              this.$refs.documentBackImage.file = undefined;
            }
            this.getDoumentDetail();
            this.$refs.confirmationPopup.closeModal();
          })
          .catch(() => {});
      }
    },
    uploadnewDocuemnt(type) {
      this.documentDetail.back_image = null;
      this.documentDetail.front_image = null;
      this.documentDetail.id_number = null;
      this.$refs.documentFrontImage.selectFile = null;
      this.$refs.documentBackImage.selectFile = null;
      this.$refs.documentFrontImage.url = null;
      this.$refs.documentBackImage.url = null;
      this.$refs.documentFrontImage.file_type = null;
      this.$refs.documentBackImage.file_type = null;
      this.isChecked = false;
      this.getDoumentDetail(type);
    },
    getDoumentDetail(type) {
      if (this.$refs.errorComponent) {
        this.$refs.errorComponent.updateFormLoader(true);
      }
      this.$api
        .getAPI({
          _action: "/document/detail",
        })
        .then((res) => {
          if (res) {
            if (type) {
              if (type == res.type) {
                this.isChecked = true;
                this.documentDetail = res;
              }
            } else {
              this.isChecked = true;
              this.documentDetail = res;

              this.$refs.documentFrontImage.selectFile = undefined;
              this.$refs.documentBackImage.selectFile = undefined;
              this.$refs.documentFrontImage.file = undefined;
              this.$refs.documentBackImage.file = undefined;
              this.$refs.documentFrontImage.file_type = undefined;
              this.$refs.documentBackImage.file_type = undefined;
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.updateFormLoader(false);
          }
        })
        .catch(() => {
          this.$refs.errorComponent.updateFormLoader(false);
        });
    },
    saveDocument() {
      if (!this.isChecked) {
        this.$notify({
          type: "error",
          text: "Please accept the declaration before submit.",
        });
        return;
      }
      if (
        !this.$refs.documentFrontImage.file &&
        !this.documentDetail.front_image
      ) {
        this.$notify({
          type: "error",
          text: "Please upload front image.",
        });
        return;
      }
      if (
        !this.$refs.documentBackImage.file &&
        !this.documentDetail.back_image &&
        this.documentDetail.type != "PANCARD"
      ) {
        this.$notify({
          type: "error",
          text: "Please upload back image.",
        });
        return;
      }
      this.$api
        .postAPI({
          _action: "/add/document",
          _body: this.documentDetail,
          _buttonId: "submit-Button",
        })
        .then((res) => {
          if (this.$refs.documentFrontImage.file) {
            this.uploadImage(
              res.uuid,
              "FRONT",
              this.$refs.documentFrontImage.file
            );
          } else if (this.$refs.documentBackImage.file) {
            this.uploadImage(
              res.uuid,
              "BACK",
              this.$refs.documentBackImage.file
            );
          } else {
            this.$notify({
              type: "success",
              text: "Document uploaded successfully.",
            });
          }
        })
        .catch(() => {});
    },
    uploadImage(uuid, image_type, file, type) {
      var is_remove = 0;
      if (
        !this.$refs.documentBackImage.file ||
        !this.documentDetail.back_image
      ) {
        is_remove = 1;
      }
      this.$api
        .uploadImageAPI({
          _action: "/add/document/photo",
          _key: "image",
          _file: file,
          _body: {
            uuid: uuid,
            image_type: image_type,
            is_remove: is_remove,
          },
        })
        .then(() => {
          if (this.$refs.documentBackImage.file && !type) {
            this.uploadImage(
              uuid,
              "BACK",
              this.$refs.documentBackImage.file,
              true
            );
          } else {
            this.$refs.documentFrontImage.selectFile = undefined;
            this.$refs.documentBackImage.selectFile = undefined;
            this.$refs.documentFrontImage.file = undefined;
            this.$refs.documentBackImage.file = undefined;
            this.$refs.documentFrontImage.file_type = undefined;
            this.$refs.documentBackImage.file_type = undefined;

            this.getDoumentDetail();

            this.$notify({
              type: "success",
              text: "Document uploaded successfully.",
            });
          }
        });
    },
  },
};
</script>
